<!--修改代理商-->
<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">{{ data.id ? "编辑合作伙伴" : "新增合作伙伴" }}</span>
      </div>
    </div>
    <!-- <div class="aid_extract">
      <div class="title">合作伙伴提成:</div>
      <div v-if="checkAccess()">
        <InputNumber v-model="data.aid_extract" :max="100" :min="0"></InputNumber>
        <span> % </span>
        <Button type="warning" @click="extract">保存</Button>
      </div>
      <div class="value" v-if="!checkAccess()">{{data.aid_extract}}%</div>
    </div> -->
    <Form ref="formInline" :model="data" :rules="rule" :label-width="250">
      <Row v-if="user.tp === 0">
        <Col span="8">
          <FormItem label="平台交易手续费 (云知印产品):" required>
            <div class="aid_extract">
              <div v-if="checkAccess()">
                <InputNumber v-model="data.aid_extract" :max="100" :min="0"></InputNumber>
                <span> % </span>
              </div>
              <!-- <div class="value" v-if="!checkAccess()">{{ data.aid_extract }}%</div> -->
            </div>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem label="平台交易手续费 (云知印mini/冲印订单）：" required label-width="300">
            <div class="dp_extract">
              <div v-if="checkAccess()">
                <InputNumber v-model="data.dp_extract" :max="100" :min="0"></InputNumber>
                <span> % </span>
              </div>
              <!-- <div class="value" v-if="!checkAccess()">{{ data.dp_extract }}%</div> -->
            </div>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem label="平台交易手续费 (场景打印)：" required>
            <div class="special_extract">
              <div v-if="checkAccess()">
                <InputNumber v-model="data.special_extract" :max="100" :min="0"></InputNumber>
                <span> % </span>
              </div>
              <!-- <div class="value" v-if="!checkAccess()">{{ data.dp_extract }}%</div> -->
            </div>
          </FormItem>
        </Col>
      </Row>
      <FormItem v-if="data.id" label="编号:">
        <div class="item_form">
          <span>{{ data.id }}</span>
          <span style="margin: 0 15px">创建时间:</span>
          <span>{{ $moment(data.create_time) }}</span>
        </div>
      </FormItem>
      <FormItem prop="tel" label="账号:">
        <input
          class="ivu-input ivu-input-default"
          v-model="data.tel"
          style="width: 300px"
          :disabled="data.id ? true : false"
          onkeyup="value=value.replace(/[^\w\u4E00-\u9FA5]/g, '')"
        />
      </FormItem>
      <FormItem prop="agent_name" label="名称:">
        <Input v-model="data.agent_name" class="item_form" />
      </FormItem>
      <FormItem prop="leader_tel" label="负责人:">
        <Input v-model="data.leader_tel" class="item_form" />
        <!-- disabled -->
      </FormItem>
      <!-- <FormItem prop="switch" label="云知印开关:">
        <div class="item_form">
          <i-switch v-model="data.is_shop" />
          <span style="margin: 0 15px">云知印开关:</span>
          <i-switch v-model="data.is_aid" />
        </div>
      </FormItem> -->
      <FormItem prop="al" label="地区:" required>
        <div style="display: flex; align-items: center">
          <al-selector
            :gutter="0"
            dataType="name"
            style="width: 392px"
            searchable
            v-model="data.al"
            level="2"
          />
          <Input
            class="item_form"
            style="margin-left: 10px"
            v-model="data.address"
            placeholder="详细地址（请勿重复填入省市区）"
          />
        </div>
      </FormItem>
      <FormItem prop="email" label="邮箱:">
        <Input v-model="data.email" class="item_form" />
      </FormItem>
      <FormItem prop="contacts_name" label="联系人:">
        <Input v-model="data.contacts_name" class="item_form" />
      </FormItem>
      <FormItem prop="contacts_tel" label="联系人手机号:">
        <Input v-model="data.contacts_tel" class="item_form" />
      </FormItem>
      <FormItem prop="service_tel" label="服务电话:">
        <Input v-model="data.service_tel" class="item_form" maxlength="12" />
      </FormItem>
      <!-- <FormItem prop="wx_code" label="微信账号:">
        <Input v-model="data.wx_code" style="width: 200px"/>
      </FormItem>
      <FormItem prop="ali_code" label="支付宝:">
        <Input v-model="data.ali_code" style="width: 200px"/>
      </FormItem> -->
      <FormItem prop="bank_name" label="开户银行:">
        <Input v-model="data.bank_name" class="item_form" />
      </FormItem>
      <FormItem prop="bank_code" label="对公银行账号:">
        <Input v-model="data.bank_code" class="item_form" />
      </FormItem>
      <FormItem prop="note" label="备注:">
        <Input v-model="data.note" class="item_form" />
      </FormItem>
      <FormItem prop="is_activation" label="在线购买运营期:" v-if="checkAccess()">
        <i-switch
          v-model="data.is_activation"
          size="large"
          :true-value="1"
          :false-value="0"
        >
          <span slot="open">允许</span>
          <span slot="close">禁止</span>
        </i-switch>
      </FormItem>
      <FormItem prop="is_tmall" label="天猫校园:" v-if="checkAccess()">
        <i-switch
          v-model="data.is_tmall"
          size="large"
          :true-value="1"
          :false-value="0"
        >
          <span slot="open">是</span>
          <span slot="close">否</span>
        </i-switch>
      </FormItem>
      <br />
      <!-- <FormItem prop="service_tel" label="设备服务电话:">
        <Input v-model="data.service_tel" style="width: 200px"/>
      </FormItem>
      <FormItem prop="logo" label="logo:">
        <div style="width: 141px;">
          <img v-if="data.logo" :src="data.logo" style="width: 141px"/>
          <br v-if="data.logo"/>
          <label class="ivu-btn ivu-btn-default" for="logo">预览图片</label>
          <input type="file" id="logo" style="position:absolute; clip:rect(0 0 0 0);"
            accept="image/png" @change="choose($event,0)">
        </div>
      </FormItem> -->
      <br />
      <FormItem>
        <Button @click="$router.back()" style="margin-right: 10px">取消</Button>
        <Button
          :type="data.id ? 'warning' : 'success'"
          :loading="loading"
          v-preventReClick
          @click="submit"
          >确定</Button
        >
      </FormItem>
    </Form>

    <!-- <Modal width="600px" v-model="cropper.visible" title="设备LOGO">
      <VueCropper
        ref="cropper"
        style="width: 1024;height: 320px"
        :img="cropper.preview"
        :autoCropWidth="cropper.autoCropWidth"
        :autoCropHeight="cropper.autoCropHeight"
        :autoCrop="cropper.autoCrop"
        :fixedBox="cropper.fixedBox"
        :outputSize="cropper.outputSize / 100"
        :enlarge="cropper.enlarge"
      ></VueCropper>
      <div slot="footer">
        <Button @click="setLogo">确定</Button>
      </div>
    </Modal> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { hasOneOf } from '@/libs/tools'
import { VueCropper } from 'vue-cropper'
export default {
  components: { VueCropper },
  data () {
    return {
      data: {
        al: ['', '', ''],
        is_activation: 1,
        is_tmall: 0,
        aid_extract: 99,
        dp_extract: 95,
        special_extract: 99
      },

      // logo: "",
      // service_tel: "",

      loading: false,
      rule: {
        aid_extract: [{ required: true, message: '请输入合作伙伴提成', trigger: 'blur' }],
        special_extract: [{ required: true, message: '请输入特殊订单提成', trigger: 'blur' }],
        dp_extract: [{ required: true, message: '请输入云知印mini提成', trigger: 'blur' }],
        tel: [{ required: true, message: '请输入公司登录账号', trigger: 'blur' }],
        agent_name: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
        email: [{ required: true, message: '请输入邮箱', trigger: 'blur' }],
        contacts_name: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        contacts_tel: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        service_tel: [
          {
            required: true,
            message: '请输入服务电话',
            trigger: 'blur',
            maxLength: 12
          }
        ]
      }
      // cropper: {
      //   visible: false,
      //   preview: "", //预览 base64
      //   autoCrop: true,
      //   outputSize: 100, //图片质量
      //   // 只有自动截图开启 宽度高度才生效
      //   autoCropWidth: 124,
      //   autoCropHeight: 19,
      //   fileType: "",
      //   fixedBox: true,
      //   enlarge: 2
      // },
    }
  },
  mounted () {
    // 判断新增 修改
    if (this.$route.params.id) {
      // 修改
      this.getAgentInfo(this.$route.params.id).then((res) => {
        res.is_aid = !!res.is_aid
        res.is_shop = !!res.is_shop
        res.is_tmall = Number(res.is_tmall) === 1 ? 1 : 0
        res.al = [res.province, res.city, res.area]
        this.data = res
        // this.service_tel = JSON.parse(JSON.stringify(res)).service_tel
      })
    } else {
      // 新增
    }
  },
  methods: {
    checkAccess () {
      return hasOneOf(['0'], this.access)
    },
    doSave () {
      let user_agent = {
        name: this.data.agent_name,
        contacts_name: this.data.contacts_name,
        contacts_tel: this.data.contacts_tel,
        service_tel: this.data.service_tel,
        contacts_telepone: this.data.contacts_telepone,
        address: this.data.address,
        province: this.data.al[0],
        city: this.data.al[1],
        area: this.data.al[2],
        is_aid: 1,
        // is_shop: this.data.is_shop ? 1 : 0,
        is_del: 0, // 启用
        wx_code: this.data.wx_code,
        ali_code: this.data.ali_code,
        bank_name: this.data.bank_name,
        bank_code: this.data.bank_code,
        note: this.data.note,
        email: this.data.email,
        is_activation: this.data.is_activation,
        is_tmall: Number(this.data.is_tmall) === 1 ? 1 : 0,
        leader_tel: this.data.leader_tel
        // logo: this.data.logo
      }
      this.loading = true
      if (this.data.id) {
        user_agent.id = this.data.id
        this.saveAgent({
          user: {
            id: this.data.user_id,
            tel: this.data.tel,
            name: this.data.agent_name
          },
          user_agent: user_agent
        }).then((res) => {
          this.loading = false
          if (res.status) {
            this.$Message.success('修改成功')
            this.$router.back()
            // if(this.logo || this.service_tel !== this.data.service_tel){
            //   this.socketSend({ action: 10006, value: { agent_id: this.data.id,logo: this.data.logo,service_tel: this.data.service_tel } })
            // }
          } else {
            this.$Message.error('修改失败,名称已存在')
          }
        })
      } else {
        let user = {
          tel: this.data.tel,
          name: this.data.agent_name,
          is_agent: 1,
          password: '123456'
        }
        this.insertAgent({ user: user, user_agent: user_agent }).then((res) => {
          this.loading = false
          if (res.status) {
            this.data.id = res.agent_id
            this.data.user_id = res.user_id
            this.$Message.success('新增成功')
            this.$router.back()
          } else {
            this.$Message.error(res.log)
          }
        })
      }
    },
    submit () {
      if (!this.data.al || !this.data.address) {
        this.$Message.error('请完善联系地址')
        return
      }
      if (this.data.aid_extract === null) {
        this.$Message.error('合作伙伴提成不能为空')
        return
      }
      if (this.data.dp_extract === null) {
        this.$Message.error('云知印mini提成不能为空')
        return
      }
      if (this.data.special_extract === null) {
        this.$Message.error('特殊订单提成不能为空')
        return
      }
      if (this.data.id) {
        this.saveExtract({
          id: this.data.id,
          aid_extract: this.data.aid_extract,
          dp_extract: this.data.dp_extract,
          special_extract: this.data.special_extract
        }).then((res) => {
          if (!res) {
            this.$Message.error(res.msg)
          }
        })
      }
      this.$refs.formInline.validate((valid) => {
        if (valid) {
          this.doSave()
          // if(this.logo){
          //   let formData = new FormData();
          //   formData.append("file",this.logo,"temp.png")
          //   this.SaveLogo(formData).then(res=>{
          //     this.data.logo = res
          //     this.doSave();
          //   });
          // }else{
          //   this.doSave()
          // }
        }
      })
    },
    // 选择图片
    // choose(e,type){
    //   let file = e.target.files[0];
    //   if(file){
    //     if(file.type !== "image/png"){
    //       this.$Message.error("仅支持png图片")
    //       return
    //     }
    //     this.cropper.visible = true
    //     let temp = file.name.split(".");
    //     this.cropper.fileType = temp[temp.length - 1];
    //     var reader = new FileReader();
    //     reader.readAsDataURL(file);
    //     reader.onload = (e)=>{
    //       this.cropper.preview = e.currentTarget.result;
    //     }
    //   }
    // },
    // setLogo(){
    //   this.$refs.cropper.getCropData(base64=>{
    //     this.data.logo = base64;
    //     this.cropper.visible = false;
    //   })
    //   this.$refs.cropper.getCropBlob(data => {
    //     this.logo = data
    //   })
    // },
    ...mapActions([
      'getAgentInfo',
      'saveAgent',
      'insertAgent',
      'saveExtract',
      'SaveLogo',
      'socketSend'
    ])
  },
  computed: mapGetters({
    access: 'access',
    user: 'agent'
  })
}
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
